import { request } from '@koi-design/vix-tools';

import { prefixApi } from './urls';

// 获取Copilot值数据
export const getCopilotValueApi = data =>
  request({
    url: `${prefixApi}/copilot/getValue`,
    method: 'post',
    headers: {
      merchantId: '2025070802'
    },
    data
  });

// 获取Copilot其他值数据
export const getCopilotOtherValueApi = data =>
  request({
    url: `${prefixApi}/copilot/getOtherValue`,
    method: 'post',
    headers: {
      merchantId: '2025070802'
    },
    data
  });

// 获取Copilot值数据
export const qryCopilotValueApi = data =>
  request({
    url: `${prefixApi}/copilot/qryCopilotValue`,
    method: 'post',
    data
  });

// 获取Copilot2值数据
export const getCopilotValueByTaskIdApi = data =>
  request({
    url: `${prefixApi}/copilot/getCopilotValueByTaskId`,
    method: 'post',
    data
  });

// 获取Copilot对话数据
export const qryCopilotDialogApi = data =>
  request({
    url: `${prefixApi}/copilot/qryCopilotDialog`,
    method: 'post',
    data
  });

// 获取资产配置历史数据
export const qryCopilotHistoryInsightsApi = data =>
  request({
    url: `${prefixApi}/copilot/getCopilotAssetHistoryInfo`,
    method: 'get',
    data
  });

// 获取资产配置历史数据
export const getCopilotHistoryInfoApi = data =>
  request({
    url: `${prefixApi}/copilot/getCopilotHistoryInfo`,
    method: 'get',
    data
  });
